import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { withRouter, useHistory } from "react-router-dom";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import NumberFormat from "react-number-format";
import useTokenCheck from "../../hooks/useTokenCheck";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import SubscribeContext from "../../context/subscribe/SubscribeContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import useEntityContext from "../../hooks/entity-context";
import Preloader from "./../layout/Preloader";
import ActionMenu from "../layout/ActionMenu";
import "./UnregRechargeValue.css";
import {
  ADD_RS_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION,
  GET_PAYMENT,
} from "../../context/types";
import useForm from "../../hooks/useForm";
import usePageTitle from "../../hooks/usePageTitle";

const PatronSubscribe = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);
  // const cartContext = useContext(CartContext);
  const subscribeContext = useContext(SubscribeContext);

  const {
    loaded,
    getConfigValue,
    getConfigValueByCode,
    getConfigValueByName,
    getConfigValueByNamePatron,
  } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { token, user } = authContext;
  const {
    cards,
    isLoading,
    selectedCard,
    subscriptionContract,
    modifySubscription,
    clearCurrentCard,
    checkSubscriptionAllowed,
    loadUserCards,
  } = cardContext;
  // const { loading, addSubscription } = cartContext;
  const navigationContext = useContext(NavigationContext);
  const {
    navigationBack,
    resetNavigationState,
    setCartAction,
    setNavigationPage,
    navigationTo,
  } = navigationContext;
  const { initSubscribeCard } = subscribeContext;
  const [loading, updateEntity] = useEntityContext();
  const history = useHistory();

  // const rechargeValues = [10, 20, 30, 40, 50, 100, 200];

  const [card, setCard] = useState({
    cardnumber: "",
    contractid: "",
    rechargevalue: "",
    thresholdAmount: "",
    maxRecharges: "",
    currentCard: null,
  });
  let {
    cardnumber,
    contractid,
    rechargevalue,
    thresholdAmount,
    maxRecharges,
    currentCard,
  } = card;
  // let currentCard = null;
  const [isRechargeable, setIsRechargeable] = useState(false);
  const [isCardSelected, setIsCardSelected] = useState(false);
  const [isContractSelected, setIsContractSelected] = useState(false);
  const [labels, setLabels] = useState({
    cardnumber: "",
    contract: "",
    rechargevalue: "",
    thresholdAmount: "",
    maxRecharges: "",
  });
  const [refCards, setRefCards] = useState();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Single Subscribe",
  });

  useEffect(() => {
    clearAlerts();
    console.log("checking navigation", navigationBack, navigationTo);
    if (navigationTo !== "subscribe-billing") {
      if (navigationBack) {
        resetNavigationState();
      } else {
        console.log("RESETing");
        clearCurrentCard();
        modifySubscription(null);
      }
    }
    let cardnumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.cardNumber"
    );
    let contract = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.contract"
    );
    let rechargevalue = getConfigValueByNamePatron(
      "generalConfig",
      "Label",
      "label.pRechargeAmount"
    );
    let thresholdAmount = getConfigValueByNamePatron(
      "generalConfig",
      "Label",
      "label.pThresholdAmount"
    );
    let maxRecharges = getConfigValueByNamePatron(
      "generalConfig",
      "Label",
      "label.pMaximumRecharges"
    );
    setLabels({
      ...labels,
      cardnumber,
      contract,
      rechargevalue,
      thresholdAmount,
      maxRecharges,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  useEffect(() => {
    if (!cards.length > 0 && !user.sponsor) {
      loadUserCards({}, token);
    } else {
      setRefCards(cards);
    }

    clearAlerts();
    // console.log("checking navigation", navigationBack);
    // if (navigationBack) {
    //   resetNavigationState();
    // } else {
    //   console.log("RESETing");
    //   clearCurrentCard();
    //   modifySubscription(null);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cardnumberRef = useRef(null);
  const contractRef = useRef(null);
  const rechargevalueRef = useRef(null);
  const thresholdAmountRef = useRef(null);
  const maxRechargesRef = useRef(null);

  const isUpdate =
    subscriptionContract &&
    subscriptionContract.subscriptionInfo.state === "Active";
  console.log("subscriptionContract", subscriptionContract);
  useEffect(() => {
    clearAlerts();
    console.log("checking navigation", navigationBack);
    if (navigationTo !== "subscribe-billing") {
      if (navigationBack) {
        resetNavigationState();
      } else {
        console.log("RESETing");
        clearCurrentCard();
        modifySubscription(null);
      }
    }
    if (selectedCard && navigationBack) {
      let contractid = card.contractid ? card.contractid : "";
      let rechargevalue = card.rechargevalue ? card.rechargevalue : "";
      let thresholdAmount = card.thresholdAmount ? card.thresholdAmount : "";
      let maxRecharges = card.maxRecharges ? card.maxRecharges : "";
      setRefCards([selectedCard]);
      setIsCardSelected(true);
      if (subscriptionContract) {
        contractid = subscriptionContract.subscriptionInfo.contractId;
        setIsContractSelected(true);
        if (
          subscriptionContract.subscriptionInfo.rechargeValue.rechargeValue > 0
        ) {
          maxRecharges =
            subscriptionContract.subscriptionInfo.maxNumberOfRechargesPerPeriod;
          thresholdAmount = (
            subscriptionContract.subscriptionInfo.trigger.threshold / 100
          ).toFixed(2);
          rechargevalue = (
            subscriptionContract.subscriptionInfo.rechargeValue.rechargeValue /
            100
          ).toFixed(2);
          console.log(
            "INSIDE  subscriptionContract.subscriptionInfo.rechargeValue.rechargeValue > 0",
            maxRecharges,
            thresholdAmount,
            rechargevalue
          );
        }
      }
      setCard({
        ...card,
        currentCard: selectedCard,
        cardnumber: selectedCard.id,
        contractid,
        maxRecharges,
        thresholdAmount,
        rechargevalue,
      });
      setUnformattedValues({
        ...unformattedValues,
        rechargevalue,
        thresholdAmount,
      });
    }
    //eslint-disable-next-line
  }, [selectedCard]);
  console.log("CARD SET", maxRecharges, thresholdAmount, rechargevalue);

  const onChange = (e) => {
    let selectedContract = "";
    if (
      e.target.name === "thresholdAmount" ||
      e.target.name === "rechargevalue"
    ) {
      return true;
    }
    if (e.target.name === "contractid") {
      selectedContract = e.target.selectedOptions[0].text;
    } else if (e.target.name === "cardnumber") {
      clearAlerts();
      if (e.target.value !== "") {
        currentCard = getSelectedCard(e.target.value)[0];
        console.log("currentCard...", currentCard);
        cardnumber = currentCard.id;
      }
      // else {
      //   currentCard = null;
      //   cardnumber = "";
      // }
    }
    setCard({
      ...card,
      [e.target.name]: e.target.value,
      selectedContract,
      cardnumber,
      currentCard,
    });
  };

  const getSelectedCard = (cardId) => {
    return refCards.filter((iCard) => {
      // console.log(
      //   "TYPEOF",
      //   typeof cardId,
      //   typeof iCard.id,
      //   "Match",
      //   parseInt(iCard.id) == cardId,
      //   iCard.id == cardId
      // );
      return iCard.id === parseInt(cardId);
    });
  };
  const { hasTokenExpired } = useTokenCheck();
  const onSubmit = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    clearAlerts();
    const card = {
      contractid,
      rechargevalue: rechargevalue * 100,
      thresholdAmount: thresholdAmount * 100,
      maxRecharges,
    };
    initSubscribeCard(card);
    setCartAction("subscribe");
    console.log("Redirecting to billing: ");
    if (!user.sponsor) history.push("/subscribe-billing");
    else {
      //Submit Order for RideSponsor
      const resStatus = await updateEntity(card, ADD_RS_SUBSCRIPTION);
      if (resStatus) {
        history.push("/user-cart");
      }
    }
  };
  const onUpdate = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    clearAlerts();
    const card = {
      contractid,
      rechargevalue: rechargevalue * 100,
      thresholdAmount: thresholdAmount * 100,
      maxRecharges,
    };
    const resStatus = await updateEntity(card, UPDATE_SUBSCRIPTION);
    if (resStatus) {
      history.push("/user-cart");
    }
  };
  const onUpdatePayment = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    clearAlerts();
    const card = {
      contractid,
      cardSerialNumber: currentCard.serialNumber,
    };
    initSubscribeCard(card);
    const res = await updateEntity(card, GET_PAYMENT);
    console.log("Response(Payment): ", res);
    setNavigationPage("subscribe-billing");
    // const sampleRes = {
    //   firstName: null,
    //   lastName: null,
    //   cardNumber: "4127",
    //   cvvCode: "123",
    //   cardType: 3,
    //   month: "12",
    //   year: "2022",
    //   address1: "123 Main st",
    //   address2: null,
    //   city: null,
    //   state: "OH",
    //   zipCode: null,
    // };
    history.push({
      pathname: "/subscribe-billing",
      state: { cardDetails: res },
    });
  };

  const onCancel = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    clearAlerts();
    const card = {
      contractid: contractid,
      rechargevalue: rechargevalue * 100,
      thresholdAmount: thresholdAmount * 100,
      maxRecharges,
    };
    const resStatus = await updateEntity(card, CANCEL_SUBSCRIPTION);
    if (resStatus) {
      history.push("/user-cart");
    }
  };

  // const selectRechargeValue = (value) => {
  //   rechargevalue = value;
  // };

  const checkSubscription = async (contractid) => {
    try {
      const res = await checkSubscriptionAllowed({ contractid }, token);
      console.log("$SUBS Allowed:", res);
      if (res && !res.allowed) {
        console.log(
          "$SUBS NOT Allowed:",
          `The subscription operation is not allowed on Q Card® with serial # ${cardnumber} [Reason:${res.description}]`
        );
        const errorDescription = `The subscription operation is not allowed on Q Card® with serial # ${
          getSelectedCard(cardnumber)[0]?.serialNumber
        } \n[Reason:${res.description}]`;
        setIsRechargeable(false);
        clearAlerts();
        setAlert(errorDescription, "warning");
      } else {
        setIsRechargeable(true);
      }
    } catch (err) {
      console.log("$ERR:", err.message);
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  useEffect(() => {
    if (contractid && !isUpdate) {
      checkSubscription(contractid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractid]);

  // const [validationRules, setValidationRules] = useState([]);

  function Popover(props) {
    // const [show, setShow] = useState(false);
    // const target = useRef(null);
    const { target, show, message } = props;
    return (
      <>
        {/* <Button ref={target} onClick={() => setShow(!show)}>
          Click me!
        </Button> */}
        <Overlay
          target={target.current}
          show={show}
          placement="right"
          message={message}
        >
          {(props) => (
            <Tooltip id="overlay-tooltip" {...props}>
              {message ? message : "Help Text goes here...."}
            </Tooltip>
          )}
        </Overlay>
      </>
    );
  }

  const [fieldRef, setFieldRef] = useState(null);
  const [helpMessage, setHelpMessage] = useState("");
  const [showHelp, setShowHelp] = useState(null);
  const helpControl = [];
  helpControl["thresholdAmount"] = useRef(null);
  helpControl["rechargevalue"] = useRef(null);
  helpControl["maxRecharges"] = useRef(null);
  // helpControl["password"] = useRef(null);
  // helpControl["password"] = useRef(null);
  const getFeildRange = (helpCtrl) => {
    let minVal = 0.0;
    let maxVal = 0.0;
    let msgCode = 0;
    if (helpCtrl === "thresholdAmount") {
      minVal = (
        getConfigValue(
          "generalConfig",
          "Minimum_Threshold_Amount",
          "Subscription_Config"
        ) / 100
      ).toFixed(2);
      maxVal = (
        getConfigValue(
          "generalConfig",
          "Maximum_Threshold_Amount",
          "Subscription_Config"
        ) / 100
      ).toFixed(2);
      msgCode = 456;
    } else if (helpCtrl === "rechargevalue") {
      minVal = (
        getConfigValue(
          "generalConfig",
          "Minimum_Recharge_Amount",
          "Subscription_Config"
        ) / 100
      ).toFixed(2);
      maxVal = (
        getConfigValue(
          "generalConfig",
          "Maximum_Recharge_Amount",
          "Subscription_Config"
        ) / 100
      ).toFixed(2);
      msgCode = 455;
    } else if (helpCtrl === "maxRecharges") {
      minVal = getConfigValue(
        "generalConfig",
        "Subscription_Min_Frequency",
        "Subscription_Config"
      );
      maxVal = getConfigValue(
        "generalConfig",
        "Subscription_Max_Frequency",
        "Subscription_Config"
      );
      msgCode = 457;
    }
    return [minVal, maxVal, msgCode];
  };

  const getHelpMessage = (helpCtrl) => {
    let [minVal, maxVal] = getFeildRange(helpCtrl);
    const prefix = helpCtrl !== "maxRecharges" ? "$" : "";
    return `Minimum: ${prefix}${minVal} \nMaximum: ${prefix}${maxVal}`;
  };
  const showTooltip = (helpCtrl) => {
    const message = getHelpMessage(helpCtrl);
    setHelpMessage(message);
    console.log("Show Tooltip ", message);
    console.log("Show Tooltip", helpCtrl);
    setFieldRef(helpControl[helpCtrl]);
    setShowHelp(true);
  };
  const removeTooltip = (e) => {
    console.log("Hide Tooltip");
    setHelpMessage("");
    setFieldRef(null);
    setShowHelp(false);
  };

  const checkFieldRange = (value, fieldName) => {
    //get allowed ranges for the given field
    console.log("Custom Field", fieldName);
    console.log("Custom value", value);
    let [minVal, maxVal, msgCode] = getFeildRange(fieldName);
    console.log("Custom Field Min", minVal, " Max ", maxVal);
    let res = !(value >= minVal && value <= maxVal)
      ? getConfigValueByCode("generalConfig", "RESPONSE_MSG", msgCode)
      : "";
    res = res.replace("{0}", minVal);
    res = res.replace("{1}", maxVal);
    console.log("Custom Field res ", res);
    //check the value is within the range
    return res;
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
    unformattedValues,
    setUnformattedValues,
  } = useForm({
    inputList: {
      cardnumber: cardnumberRef,
      contractid: contractRef,
      rechargevalue: rechargevalueRef,
      thresholdAmount: thresholdAmountRef,
      maxRecharges: maxRechargesRef,
    },
    screenName: "add_subscription",
    unformattedValuesList: {
      thresholdAmount: 0.0,
      rechargevalue: 0.0,
    },
    customRules: {
      rechargevalue: checkFieldRange,
      thresholdAmount: checkFieldRange,
      maxRecharges: checkFieldRange,
    },
    excludePrefix: {
      rechargevalue: true,
      thresholdAmount: true,
      maxRecharges: true,
    },
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card]);

  return (
    <Fragment>
      <Popup />
      {(loading || isLoading) && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronHome"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 className="privateView__pageTitle">
          {isUpdate ? "MANAGE" : "ADD"} SUBSCRIPTION{" "}
          {fieldRef && (
            <Popover target={fieldRef} show={showHelp} message={helpMessage} />
          )}
          <div className="privateView__pageTitle__note">
            {/* <span className="required">*</span>denotes a required field */}
          </div>
        </h1>
        <div className="pvtUnregRecharge__formBody">
          <form>
            <div className="pvtUnregRecharge__formGroup">
              <label htmlFor="cardnumber" className="defaultFillLabel">
                {labels.cardnumber}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <select
                aria-required="true"
                name="cardnumber"
                id="cardnumber"
                className="form-control defaultFillText"
                onChange={onChange}
                value={cardnumber}
                onBlur={(e) => validateField(e, labels.cardnumber)}
                ref={cardnumberRef}
                disabled={isCardSelected}
              >
                <option value="">--SELECT--</option>
                {refCards &&
                  refCards.map((iCard) => (
                    <option key={iCard.id} value={iCard.id}>
                      {iCard.serialNumber || ":" || iCard.profileName}
                    </option>
                  ))}
              </select>
              <div></div>
            </div>
            <div className="pvtUnregRecharge__formGroup">
              <label htmlFor="contractid">
                {labels.contract}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <select
                aria-required="true"
                name="contractid"
                id="contractid"
                className="form-control"
                onChange={onChange}
                value={contractid}
                // disabled={
                //   subscriptionContract &&
                //   subscriptionContract.subscriptionInfo.state === "Active"
                // }
                onBlur={(e) => validateField(e, labels.contract)}
                ref={contractRef}
                disabled={isContractSelected}
              >
                <option value="">--SELECT--</option>
                {currentCard &&
                  currentCard.contracts
                    .filter((contract) => !contract.rideSponsorContract)
                    .map((contract) => (
                      <option key={contract.id} value={contract.id}>
                        {contract.contractName}
                      </option>
                    ))}
              </select>
              <div></div>
            </div>
            <div className="pvtUnregRecharge__formGroup__subform">
              <h2 className="pvtUnregRecharge__formGroup__subform__title">
                Subscription Options
              </h2>
            </div>
            <div className="pvtUnregRecharge__formGroup">
              <label htmlFor="thresholdAmount">
                {labels.thresholdAmount}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <NumberFormat
                name="thresholdAmount"
                id="thresholdAmount"
                className="form-control"
                onValueChange={(values) => {
                  setCard({
                    ...card,
                    thresholdAmount: values.value,
                  });
                  setUnformattedValues({
                    ...unformattedValues,
                    thresholdAmount: values.floatValue,
                  });
                }}
                value={thresholdAmount}
                prefix={"$"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                placeholder="$0.00"
                onBlur={(e) => validateField(e, labels.thresholdAmount)}
                getInputRef={thresholdAmountRef}
              />
              <button
                className="pvtUnregRecharge__formGroup__input-info"
                onKeyUp={(e) => showTooltip("thresholdAmount")}
                onKeyDown={(e) => removeTooltip(e)}
              >
                <i
                  aria-live="assertive"
                  id="thresholdAmountHelp"
                  name="thresholdAmountHelp"
                  ref={helpControl["thresholdAmount"]}
                  onMouseEnter={(e) => showTooltip("thresholdAmount")}
                  onMouseLeave={(e) => removeTooltip(e)}
                  className="fa fa-question mini-circle-icon"
                />
              </button>
            </div>
            <div className="pvtUnregRecharge__formGroup">
              <label htmlFor="rechargevalue">
                {labels.rechargevalue}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <NumberFormat
                name="rechargevalue"
                id="rechargevalue"
                className="form-control"
                onValueChange={(values) => {
                  setCard({
                    ...card,
                    rechargevalue: values.value,
                  });
                  setUnformattedValues({
                    ...unformattedValues,
                    rechargevalue: values.floatValue,
                  });
                }}
                value={rechargevalue}
                prefix={"$"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                placeholder="$0.00"
                onBlur={(e) => validateField(e, labels.rechargevalue)}
                getInputRef={rechargevalueRef}
              />
              <button
                className="pvtUnregRecharge__formGroup__input-info"
                onKeyUp={(e) => showTooltip("rechargevalue")}
                onKeyDown={(e) => removeTooltip(e)}
              >
                <i
                  aria-live="assertive"
                  className="fa fa-question mini-circle-icon"
                  id="rechargevalueHelp"
                  name="rechargevalueHelp"
                  ref={helpControl["rechargevalue"]}
                  onMouseEnter={(e) => showTooltip("rechargevalue")}
                  onMouseLeave={(e) => removeTooltip(e)}
                />
              </button>
            </div>
            <div className="pvtUnregRecharge__formGroup">
              <label htmlFor="maxRecharges">
                {labels.maxRecharges}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              {/* <input
                type="text"
                name="maxRecharges"
                className="form-control"
                onChange={onChange}
                value={maxRecharges}
                placeholder="0"
                onBlur={validateField}
                ref={maxRechargesRef}
              /> */}
              <NumberFormat
                className="form-control"
                id="maxRecharges"
                name="maxRecharges"
                placeholder="0"
                onValueChange={(values) => {
                  // onPopulateAllChange(values.floatValue)
                  setCard({
                    ...card,
                    maxRecharges: values.value,
                  });
                  setUnformattedValues({
                    ...unformattedValues,
                    maxRecharges: values.floatValue,
                  });
                }}
                value={maxRecharges}
                onBlur={(e) => validateField(e, labels.maxRecharges)}
                getInputRef={maxRechargesRef}
                aria-required="true"
              />
              <button
                className="pvtUnregRecharge__formGroup__input-info"
                onKeyUp={(e) => showTooltip("maxRecharges")}
                onKeyDown={(e) => removeTooltip(e)}
              >
                <i
                  aria-live="assertive"
                  className="fa fa-question mini-circle-icon"
                  id="maxRechargesHelp"
                  name="maxRechargesHelp"
                  ref={helpControl["maxRecharges"]}
                  onMouseEnter={(e) => showTooltip("maxRecharges")}
                  onMouseLeave={(e) => removeTooltip(e)}
                />
              </button>
            </div>
            <div className="pvtUnregRecharge__formGroup">
              <div className="pvtUnregRecharge__l-pillFill"></div>
              {/* <div className="pvtUnregRecharge__pillList">
                        {rechargeValues.map((item, index)=>(
                            <div className="pill" key={index} onClick={selectRechargeValue({item})}>${item}</div>
                        ))}
                    </div> */}
              <div className="pvtUnregRecharge__r-pillFill"></div>
            </div>
            <div className="pvtUnregRecharge__formGroup">
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="pvtUnregRecharge__formGroup__action">
              {!isUpdate ? (
                <Fragment>
                  <input
                    aria-live="assertive"
                    aria-label="PROCEED TO PAYMENT"
                    id="proceedToCart"
                    name="proceedToCart"
                    type="submit"
                    value="PROCEED TO PAYMENT"
                    className="btn btn-primary pvtUnregRecharge__formGroup__button"
                    onClick={onSubmit}
                    disabled={!isFormValid || !isRechargeable}
                  />
                  <div></div>
                  <div></div>
                </Fragment>
              ) : (
                <Fragment>
                  <input
                    aria-live="assertive"
                    aria-label="UPDATE SUBSCRIPTION "
                    id="updateSubscription"
                    name="updateSubscription"
                    type="submit"
                    value="UPDATE SUBSCRIPTION"
                    className="btn btn-primary pvtUnregRecharge__formGroup__button"
                    onClick={onUpdate}
                    ref={helpControl["updateSubscription"]}
                    onMouseEnter={(e) => showTooltip(e)}
                    onMouseLeave={(e) => removeTooltip(e)}
                    disabled={!isFormValid}
                  />
                  {!user.sponsor && (
                    <input
                      aria-live="assertive"
                      aria-label="UPDATE PAYMENT "
                      id="updatePayment"
                      name="updatePayment"
                      type="button"
                      value="UPDATE PAYMENT"
                      className="btn btn-primary pvtUnregRecharge__formGroup__button"
                      onClick={onUpdatePayment}
                    />
                  )}
                  <input
                    aria-live="assertive"
                    aria-label="CANCEL SUBSCRIPTION "
                    id="cancelPayment"
                    name="cancelPayment"
                    type="button"
                    value="CANCEL SUBSCRIPTION"
                    className="btn btn-primary pvtUnregRecharge__formGroup__button"
                    onClick={onCancel}
                  />
                </Fragment>
              )}
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(PatronSubscribe);
